var GlobalsPrototype = function (config) {
    this.config = config;
    this.tc = config.tc;
    this.links = config.links;
    this.siteCode = config.siteCode;
    this.languageCode = config.languageCode;
    this.navigationCode = config.navigationCode;
    this.gridBreakpoints = config.gridBreakpoints;
    this.sendItemToBasketByJS = config.sendItemToBasketByJS;
    this.updateBasketByJS = config.updateBasketByJS;
    this.sendFavoriteByJS = config.sendFavoriteByJS;
    this.delayHideBasketHover = config.delayHideBasketHover;
    this.loadLottieLoader = config.loadLottieLoader;
    this.delayShowFlashMessages = config.delayShowFlashMessages;
    this.delayHideFlashMessages = config.delayHideFlashMessages;
    this.preferredPhoneCountries = config.preferredPhoneCountries;
    this.offsetTopJumpmarks = config.offsetTopJumpmarks;
    this.dcCookie = config.dcCookie;

    this.initializeFormatting();
};

GlobalsPrototype.prototype = {
    initializeFormatting: function () {
        var _globalNumberFormat = new Intl.NumberFormat(this.config.localeCode, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        var _globalPriceFormat = new Intl.NumberFormat(this.config.localeCode, {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

        try {
            _globalPriceFormat = new Intl.NumberFormat(this.config.localeCode, {
                style: 'currency',
                currency: (this.config.currencyCode || 'EUR'),
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        } catch (error) {
            console.warn(error);
        }

        this.format = {
            number: _globalNumberFormat,
            price: _globalPriceFormat,
            priceParts: {},
        };

        var _testPriceFormat = _globalPriceFormat.formatToParts(1337.42);

        for (const [key, value] of Object.entries(_testPriceFormat)) {
            if (value.type === 'currency') {
                this.format.priceParts.currency = value.value;
            }

            if (value.type === 'decimal') {
                this.format.priceParts.decimal = value.value;
            }

            if (value.type === 'group') {
                this.format.priceParts.group = value.value;
            }
        }
    },

    escapeRegExp: function (string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    },

    replaceAll: function (str, find, replace) {
        return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
    },

    priceToFloat: function (priceString) {
        priceString = this.replaceAll(priceString, this.format.priceParts.currency, '');
        priceString = this.replaceAll(priceString, this.format.priceParts.group, '');
        priceString = this.replaceAll(priceString, ' ', '');

        var priceSplit = priceString.split(this.format.priceParts.decimal);
        return parseFloat(priceSplit[0] + '.' + priceSplit[1]);
    },
};

function createGlobalsFromJsonScript(scriptId) {
    const configElement = document.getElementById(scriptId || 'dc-globals-config');

    if (!configElement) {
        throw new Error('Missing globals config element');
    }

    const config = JSON.parse(configElement.textContent);

    if (config.dcCookie && config.dcCookie.lastReset) {
        config.dcCookie.lastReset = new Date(config.dcCookie.lastReset);
    }

    return new GlobalsPrototype(config);
}

export { GlobalsPrototype, createGlobalsFromJsonScript };
